import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-salvage-yard-management',
  templateUrl: './salvage-yard-management.component.html',
  styleUrls: ['./salvage-yard-management.component.css']
})
export class SalvageYardManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/dev-man/Kgwetlwo-app/src/app/pages/services/salvage-yard-management/salvage-yard-management.component.ts